<template>
	<g>
		<g id="iconTel"><path d="m444.833 124.175v-124.175h-126.092l-4.499 6.036c-.783 1.052-7.204 9.873-15.575 26.836l-21.334 223.128 21.333 223.128c8.371 16.962 14.792 25.784 15.575 26.835l4.499 6.036h126.093v-124.174l-68.857-34.429v-194.792z" fill="#fc3636"/><path d="m254.167 256c0 113.93 26.676 187.01 44.5 223.128v-446.256c-17.824 36.118-44.5 109.198-44.5 223.128z" fill="#fc5b3f"/></g><path d="m394.422 219.429c9.41-9.348 15.244-22.291 15.244-36.572 0-28.437-23.135-51.572-51.571-51.572h-59.429l-21.333 124.715 21.333 124.714h59.429c28.436 0 51.571-23.135 51.571-51.571 0-14.281-5.834-27.224-15.244-36.572 9.41-9.348 15.244-22.291 15.244-36.572.001-14.28-5.834-27.222-15.244-36.57z" fill="#ea9b58"/><path d="m219.578 131.286-13.813 29.714h-97.099v190h100.165l15.574 29.714h74.262v-249.428z" fill="#f6a96c"/><path d="m167.499 134.333h-50.166l-21.333 121.667 21.333 121.667h50.166z" fill="#f7f0eb"/><path d="m67.166 134.333h50.167v243.333h-50.167z" fill="#474f54"/>
	</g>
</template>

<script>

	import { TimelineMax } from 'gsap'

	export default {
		name: "iconTelephone",
		data: function () {
			return {
				tl:undefined,
			}
		},
		mounted() {
			this.tl = new TimelineMax({repeat:-1});
			this.start();
		},
		methods: {
			start() {
				this.tl.set('#iconTel', {rotation: -1, transformOrigin:"center"});
				this.tl.to('#iconTel', 0.4, {rotation: 1, transformOrigin:"center"});
				this.tl.to('#iconTel', 0.4, {rotation: -1, transformOrigin:"center"});
			}
		}
	}
</script>

<style scoped>

</style>
